/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popJoinArenaSelectAmount.vue?vue&type=template&id=226208c4&scoped=true"
import script from "./popJoinArenaSelectAmount.vue?vue&type=script&lang=js"
export * from "./popJoinArenaSelectAmount.vue?vue&type=script&lang=js"
import style0 from "./popJoinArenaSelectAmount.vue?vue&type=style&index=0&id=226208c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226208c4",
  null
  
)

export default component.exports